import { memo, type ReactNode } from 'react'

import { useSubscriptionState } from '@/hooks/billing/use-subscription-state.hook'
import { cn } from '@/lib/utils'
import type { BillingInterval, BillingPlan } from './billing.interface'
import { BillingPlanCard } from './billing-plan-card.molecule'

export interface BillingPlansSectionProps {
  planList: BillingPlan[]
  loadingPlanId?: string | null
  billingInterval: BillingInterval
  onSelectPlan?: (plan: BillingPlan) => void
  subscriptionsEnabled?: boolean
  className?: string
}

const BillingPlansSectionBase: React.FC<BillingPlansSectionProps> = ({
  planList,
  loadingPlanId = null,
  billingInterval,
  onSelectPlan,
  subscriptionsEnabled = true,
  className,
}): ReactNode => {
  const { subscription, isCurrentPlan } = useSubscriptionState()

  return (
    <div className={cn('billing-plans-section', className)}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {planList.map((plan) => {
          const isOtherPlanLoading = loadingPlanId !== null && plan.id !== loadingPlanId
          return (
            <BillingPlanCard
              key={plan.id}
              plan={plan}
              isCurrentPlan={isCurrentPlan(plan)}
              isCancelling={subscription.isCancelling}
              isLoading={plan.id === loadingPlanId}
              isDisabled={isOtherPlanLoading || !subscriptionsEnabled}
              billingInterval={billingInterval}
              onSelectPlan={onSelectPlan}
            />
          )
        })}
      </div>
    </div>
  )
}

export const BillingPlansSection = memo(BillingPlansSectionBase)

BillingPlansSection.displayName = 'BillingPlansSection'
